<template>
  <!--
      作者 kmdshop
      时间：2020-06-09
      描述：会员-联盟币明细
  -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" class="demo-form-inline">
        <el-form-item label="订单编号">
          <el-input v-model="order_no" placeholder="请输入订单编号"></el-input>
        </el-form-item>
        <el-form-item label="导入状态">
          <el-select v-model="status" placeholder="请选择">
            <el-option label="全部" value="0"></el-option>
            <el-option label="成功" value="1"></el-option>
            <el-option label="失败" value="2"></el-option>
          </el-select>
        </el-form-item>
         <el-form-item label="日志类型">
          <el-select v-model="type" placeholder="请选择">
            <el-option label="全部" value="0"></el-option>
            <el-option label="订单" value="1"></el-option>
            <el-option label="结算" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="content" label="订单编号"></el-table-column>

          <el-table-column prop="scene.status" label="导入状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status==1" style="color: #67C23A">导入成功</span>
              <span v-if="scope.row.status==2" style="color: red">导入失败</span>
            </template>
          </el-table-column>

          <el-table-column prop="scene.type" label="日志类型">
            <template slot-scope="scope">
              <span v-if="scope.row.type==1" style="color: #409EFF">订单</span>
              <span v-if="scope.row.type==2" style="color: #67C23A">结算</span>
            </template>
          </el-table-column>

          <el-table-column prop="ext" label="描述/说明">
            <template slot-scope="scope">
              <p v-if="scope.row.ext ==''">--</p>
              <p v-else>{{scope.row.ext}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="导入时间" width="140"></el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>


  </div>
</template>

<script>
  import OrderApi from '@/api/order.js';
  export default {

    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        order_no: '',
        type: '',
        status: ''
      };
    },
    created() {
      /*获取列表*/
      this.getTableList();

    },
    methods: {

      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = {};
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        Params.order_no = self.order_no;
        Params.type = self.type;
        Params.status = self.status;

        OrderApi.accountlog(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            // self.brandModel.brandList = self.tableData;
            self.totalDataNumber = data.data.list.total
          })
          .catch(error => {
            self.loading = false;
          });

      },

      /*搜索查询*/
      onSubmit() {
        let self = this;
        self.loading = true;
        let Params = self.formInline;
        self.getTableList();
      },


      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        if (f == 'add') {
          this.open_add = e.openDialog;
          if (e.type == 'success') {
            this.getTableList();
          }
        }
        if (f == 'edit') {
          this.open_edit = e.openDialog;
          if (e.type == 'success') {
            this.getTableList();
          }
        }
      },


    }
  };
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/order/order/accountlog.vue